module.exports = __webpack_public_path__ + "img/arrowLeft.a9e14bea.png";